export const PRODUCT_SOLD_OUT_ERROR_CODE = 703;

export const PRODUCT_SOLD_OUT_LABEL = "Ausverkauft";

// availableQuantity is the total number of sales left for a product across all
// customers. null means the product has no cap configured and is always buyable.
export const LOW_STOCK_THRESHOLD = 5;

export const isProductSoldOut = (product) => {
    const availableQuantity = product?.availableQuantity;

    if (availableQuantity === null || availableQuantity === undefined) {
        return false;
    }

    return availableQuantity <= 0;
};

export const getLowStockLabel = (product) => {
    const availableQuantity = product?.availableQuantity;

    if (availableQuantity === null || availableQuantity === undefined) {
        return null;
    }

    if (availableQuantity <= 0 || availableQuantity > LOW_STOCK_THRESHOLD) {
        return null;
    }

    return `Nur noch ${availableQuantity} verfügbar`;
};
